"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gender = void 0;
var Gender;
(function (Gender) {
    /**
     * Used to indicate male users
     */
    Gender[Gender["MALE"] = 0] = "MALE";
    /**
     * Used to indicate female users
     */
    Gender[Gender["FEMALE"] = 1] = "FEMALE";
    /**
     * Used to indicate users who don't identify as either male or female
     */
    Gender[Gender["OTHER"] = 2] = "OTHER";
})(Gender = exports.Gender || (exports.Gender = {}));
//# sourceMappingURL=gender.enum.js.map